import * as Updates from 'expo-updates';
import {setCheckingForUpdates, setError} from '../reducers/configSlice';
import {dispatchAction} from "./state/dispatchAction";
import {hideToast, showToastMessage} from "./toastMessage";
import {isWEB} from "./helpers/getPlatformType";

export async function checkAndApplyUpdates(blocking = false, silent = false) {
    if (isWEB()) {
        return;
    }

    let error = null;
    if (blocking) {
        dispatchAction(setCheckingForUpdates(true));
    }

    if (!blocking && !silent) {
        showToastMessage('Checking for updates', -1)
    }

    try {
        const update = await Updates.checkForUpdateAsync();

        if (update.isAvailable) {
            await Updates.fetchUpdateAsync();
            await Updates.reloadAsync();

            hideToast()
            return;
        }

        if (!silent) {
            showToastMessage('App is up to date', 5000)
        }
    } catch (e) {
        error = e;
        showToastMessage(e.message, 10000)
    } finally {
        dispatchAction(setCheckingForUpdates(false));
        setTimeout(() => {
            hideToast()
        }, 5000)
    }
}
